import { makeStyles } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React, { FunctionComponent } from "react";
import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const useStyles = makeStyles((theme) => ({
  body: {
    display: "flex",
    width: "100%",
    height: "100%",
  },
  icon: {
    background: "#115E67;",
    padding: "5px",
    width: "35px",
    display: "flex",
    "& svg": {
      color: "white",
      fontSize: "20px",
      margin: "auto",
    },
  },
  text: {
    padding: "5px",
    color: "white",
    background: "#00a9a3",
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    fontSize: "13px",
    paddingInlineStart: "10px",
  },
}));

const SuccessToast: FunctionComponent<{ text: string; rtl?: boolean }> = (
  props
) => {
  const ctx = useAppContext();
  const classes = useStyles();
  return (
    <div className={classes.body} dir={props.rtl ? "rtl" : "ltr"}>
      <div className={classes.icon}>
        <CheckCircleIcon />
      </div>
      <div className={classes.text}>{t(props.text)}</div>
    </div>
  );
};

const FailToast: FunctionComponent<{ text: string; rtl?: boolean }> = (
  props
) => {
  const ctx = useAppContext();
  const classes = useStyles();
  return (
    <div className={classes.body} dir={props.rtl ? "rtl" : "ltr"}>
      <div className={classes.icon}>
        <CancelIcon style={{ color: "#E58C8A" }} />
      </div>
      <div className={classes.text}>{t(props.text)}</div>
    </div>
  );
};

/**
 * example usage:
 *
 * const showToast =  useShowToast()
 *
 * showToast("success","I'm beautiful toast")
 *
 * note: the <ToastContainer/> is in app.tsx
 */
const useShowToast = () => {
  const ctx = useAppContext();

  return (type: "success" | "fail", msg: string, options?: ToastOptions) => {
    const toastUI =
      type === "success" ? (
        <SuccessToast text={msg} rtl={ctx.rtl} />
      ) : (
        <FailToast text={msg} rtl={ctx.rtl} />
      );
    toast(toastUI, {
      position: ctx.rtl ? "top-left" : "top-right",
      pauseOnFocusLoss: true,
      hideProgressBar: true,
      closeButton: <></>,
      ...options,
    });
  };
};
export default useShowToast;
